<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <q-form ref="editForm">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable"
                  label="저장"
                  icon="save" />
                <c-btn
                  v-if="editable"
                  label="삭제"
                  icon="remove" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
                <div class="col-6">
                  <c-text
                    :editable="editable"
                    label="배출시설명"
                    name="col1"
                    v-model="data.col1">
                  </c-text>
                </div>
                <div class="col-6">
                  <c-text
                    :editable="editable"
                    label="배출시설 일련번호"
                    name="col2"
                    v-model="data.col2">
                  </c-text>
                </div>
                <div class="col-3">
                  <c-plant :required="true" type="edit" name="col0" v-model="data.col0" />
                </div>
                <div class="col-3">
                  <c-dept type="edit" label="관리부서" name="col3" v-model="data.col3" />
                </div>
                <div class="col-3">
                  <c-radio
                    :editable="editable"
                    :comboItems="useFlagItems"
                    label="사용여부"
                    name="useFlag"
                    v-model="data.useFlag">
                  </c-radio>
                </div>
            </template>
          </c-card>
        </q-form>
      </div>
    </div>
  </div>
</template>
<script>
// import selectConfig from '@/js/selectConfig';
// import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'water-master03-detail',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
          psiDocumentId: '',
          documentClassCd: '',
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      data: {
        col0: '',
        col1: '배출시설1',
        col2: '1',
        col3: '',
        col4: '24',
        useFlag: 'Y',
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 220);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getData();
    },
    getData() {
    },
  }
};
</script>